import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { blacklistedIdentifierFragment } from "src/graphql/anti-fraud/fragments/BlacklistedIdentifierFragment";
import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";
import { scenarioExecutionResultWithCaseFragment } from "src/graphql/anti-fraud/fragments/ScenarioExecutionResultWithCaseFragment";
import { shortAlertFragment } from "src/graphql/anti-fraud/fragments/ShortAlertFragment";

export const caseFragment = gql`
  fragment CaseFragment on Case {
    id
    alertStatus
    configurableType {
      code
      name
    }
    elementLists {
      code
      name
      typeCode
      elements {
        id
        name
        properties {
          ...PropertyValueFragment
        }
      }
    }
    alerts {
      ...ShortAlertFragment
    }
    executionResults {
      ...ScenarioExecutionResultWithCaseFragment
    }
    snapshotCreation
    typeCode
    lastScore
    properties {
      ...PropertyValueFragment
    }
    elements {
      ...ElementFragment
    }
    blacklistedIdentifiers {
      ...BlacklistedIdentifierFragment
    }
    adminStatus {
      ...AdminStatus
    }
  }

  ${adminStatusFragment}
  ${scenarioExecutionResultWithCaseFragment}
  ${blacklistedIdentifierFragment}
  ${elementFragment}
  ${propertyValueFragment}
  ${shortAlertFragment}
`;
